import { Component, OnInit } from '@angular/core';
import { NewsService } from '../services/news.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as $ from 'jquery'

@Component({
  selector: 'app-specific-writter',
  templateUrl: './specific-writter.component.html',
  styleUrls: ['./specific-writter.component.css']
})
export class SpecificWritterComponent implements OnInit {

  writterName ; 
  newsData  ; myDataArray:any[]  = [] ; myData:any[] = []
  constructor(private _Activatedroute:ActivatedRoute , private _Router:Router , private newData:NewsService) 
  {
    this.myDataArray = []
    this.myData=[]
    this._Activatedroute.params.subscribe(params => {
      this.writterName = params['writter'];
      // reset and set based on new parameter this time
      });
      this.newsData = this.newData.newsData ;
   for(let item of this.newsData)
   {
     if(item.author === this.writterName)
     {
       this.myDataArray.push(item);
       
     }
   }
   this.myData = this.myDataArray
  }

  ngOnInit() {


   
    this._Activatedroute.params.subscribe(params => {
      this.writterName = params['writter'];
      this.myDataArray = []
      this.myData=[]
      // reset and set based on new parameter this time
      this.newsData = this.newData.newsData ;
      for(let item of this.newsData)
      {
        if(item.author === this.writterName)
        {
          this.myDataArray.push(item);
          
        }
      }
      this.myData = this.myDataArray
      });
     

      $(document).ready(function(){

        $("body").on("click",".accor li",function(){
  
          if($(this).attr("id") == "1")
          {
           $(".firs").css("display","block");
            $(".sec").css("display","none");  
             $(this).addClass("act");
             $(this).siblings().removeClass("act"); 
          }
          else{
            $(".sec").css("display","block");
            $(".firs").css("display","none"); 
            $(this).addClass("act");
             $(this).siblings().removeClass("act");
          }
  
        });
          
          });
  
 

  }
  changeURL(tag)
  {
    
    this._Router.navigate(["News/Tag",tag])
  }
}
